import { render, staticRenderFns } from "./SiteTreeContentItem.vue?vue&type=template&id=1efbcd2a&scoped=true"
import script from "./SiteTreeContentItem.vue?vue&type=script&lang=js"
export * from "./SiteTreeContentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efbcd2a",
  null
  
)

export default component.exports